import { delay } from '../utils/helpers.js';

export class FeedbackService {
	constructor(baseAPI) {
		this.api = baseAPI;
	}

	async submitFeedback(feedbackData) {
		await this.api._ensureSession();

		if (this.api.mock) {
			await delay(500);
			return {
				success: true,
				data: {
					id: 'mock_post_' + Date.now(),
					title: feedbackData.title,
					content: feedbackData.content,
				},
				message: 'Feedback submitted successfully!',
			};
		}

		const payload = {
			board:
				feedbackData.board_id || feedbackData.board || feedbackData.boardId,
			title: feedbackData.title,
			content: feedbackData.content,
			attachments: feedbackData.attachments || [],
		};

		return this.api._handleAuthRetry(async () => {
			const response = await this.api._makeRequest('/widget/feedback', {
				method: 'POST',
				body: JSON.stringify(payload),
				headers: {
					'Content-Type': 'application/json',
					Authorization: `Bearer ${this.api.sessionToken}`,
				},
			});
			return response;
		});
	}
}
